export default function unload_styles(id) {
  document.getElementById(id).remove()
}
